<template>
  <div class="d-flex">
    <template v-for="(item, index) in 4">
      <div
        class="todo-skeleton-item"
        :key="item"
        :class="{ 'me-2': index !== 3 }"
      >
        <v-card
          rounded
          outlined
          style="height: 76px"
          class="d-flex justify-space-between px-2 py-2"
        >
          <div class="d-flex flex-column justify-center">
            <v-skeleton-loader type="text" width="60" />
            <v-skeleton-loader type="text" width="20" />
          </div>
          <div class="d-flex flex-column justify-start align-start">
            <v-skeleton-loader class="d-flex" type="text" max-width="20" />
          </div>
        </v-card>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'TodoEntityCounts',

  props: {
    activeEntity: String,
    totalRevs: Number,
    totalTasks: Number,
    totalFindings: Number,
    totalRoutines: Number,
  },
}
</script>
<style lang="scss">
.todo-skeleton-item {
  flex: 1 1 0;
  width: 0;
}
</style>
